
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type TweetListResponsePageAllOfThreeContentItemMediaLinksItemLinkType = typeof TweetListResponsePageAllOfThreeContentItemMediaLinksItemLinkType[keyof typeof TweetListResponsePageAllOfThreeContentItemMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TweetListResponsePageAllOfThreeContentItemMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
